module.exports = __webpack_public_path__ + "static/banner-bdb648a1bc4c345f6e94f7352f2d1939.png";